<template>
  <!--콘텐츠 영역-->
  <div id="sub_contents" class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item NewsDK">
      <div class="tit">
        <h3 class="fNS-EB fs-36">
          페럼인프라의
          <br />새로운 소식입니다.
        </h3>
      </div>
      <div class="News_tit">
        <h4>{{ detail.title }}</h4>
        <p class="day">{{ detail.createdAt | date }}</p>
      </div>
      <div class="txt">
        <div v-html="detail.content"></div>
        <div v-if="detail.files.dnFiles && detail.files.dnFiles.length != 0">
          <div class="bnt_area" v-for="(obj, index) in detail.files.dnFiles" :key="index">
            <button class="btn_download" @click="nasDownload(obj.filename)">{{ obj.originalname }}</button>
          </div>
        </div>
      </div>

      <div class="News_btn_area">
        <button class="btn_list" @click="btnGoList">목록</button>
        <button class="btn_list fl mgr10" v-if="isAdmin" @click="btnUpdate">수정</button>
        <button class="btn_list type01 fl" v-if="isAdmin" @click="btnDelete">삭제</button>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import pm from "../common/protocolManager";
import eventBus from "../common/eventBus";
export default {
  data: () => ({
    message: "NewDongkukSystems.vue",
    isAdmin: false,
    detail: {
      title: "",
      content: "",
      createdAt: new Date(),
      files: {},
    },
  }),
  methods: {
    checkAdmin() {
      let url = "isAdmin";
      pm.get(url)
        .then((result) => {
          console.log("checkAdmin - ok");
          if (result.role === 'admin') {
            this.isAdmin = true;
          } else {
            this.isAdmin = false;
          }
        })
        .catch((err) => {
          console.log("checkAdmin - err");
          this.isAdmin = false;
        });
    },
    btnUpdate() {
      console.log("btnUpdate");
      this.$router.push(
        `/Public/NewsDetail/${this.$route.params.id}/NewsWritePopup`
      );
    },
    btnGoList() {
      console.log("btnGoList");
      this.$router.replace(`/Public/News`);
    },
    btnDelete() {
      console.log("btnDelete");

      if (confirm("정말 삭제하시겠습니까?")) {
        let url = "ferrum/newsDelete";
        let params = {
          id: this.$route.params.id,
        };
        pm.post(url, params)
          .then((result) => {
            console.log("btnDelete ok");
            alert("삭제되었습니다.");

            this.$router.replace("/Public/News");
          })
          .catch((err) => {
            console.log("btnDelete err");
            alert("삭제 실패");
          });

        //   pm.post
      }
    },
    reqDetail() {
      let url = `ferrum/newsDetail?id=${this.$route.params.id}`;
      pm.get(url)
        .then((result) => {
          console.log("btnDetail - ok");
          this.detail = result.detail;
        })
        .catch((err) => {
          console.log("btnDetail - error");
        });
    },
  },
  computed: {},
  destroyed() {
    eventBus.$off("EVENT_CHANGE_BOARD_DETAIL");
  },
  created() {
    console.log("created - " + this.message);
    this.reqDetail();
    if (localStorage.authToken) {
      this.checkAdmin();
    }

    eventBus.$on("EVENT_CHANGE_BOARD_DETAIL", () => {
      console.log("EVENT_CHANGE_BOARD_DETAIL");
      this.reqDetail();
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sub03/NewsDetail.vue